"use client";

import React from "react";
import { Search, Sparkles, X } from "lucide-react";
import { Reveal } from "@/components/cosmic/Reveal";
export const CATEGORIES = [{
  id: "all",
  label: "All Dispatches"
}, {
  id: "astrophysics",
  label: "Astrophysics"
}, {
  id: "quantum",
  label: "Quantum Mechanics"
}, {
  id: "multiverse",
  label: "Multiverse Theory"
}, {
  id: "cosmology",
  label: "Observational Cosmology"
}];
export interface SearchCategoriesProps {
  searchQuery?: string;
  onSearchChange?: (val: string) => void;
  activeCategory?: string;
  onCategoryChange?: (val: string) => void;
}
export default function SearchCategories({
  searchQuery = "",
  onSearchChange,
  activeCategory = "all",
  onCategoryChange
}: SearchCategoriesProps) {
  const handleClear = () => {
    onSearchChange?.("");
  };
  return <section id="search-and-categories" data-nav="dark" className="relative w-full max-w-full border-y border-border/80 bg-background/40 py-6 backdrop-blur-md sm:py-8 md:py-10">
      <div className="relative z-10 mx-auto w-full max-w-6xl px-4 sm:px-6 lg:px-8">
        <Reveal delay={80}>
          <div className="grid grid-cols-1 items-center gap-4 sm:gap-6 lg:grid-cols-12 lg:gap-8">
            {/* Columns 1–6: Search input with obsidian glass styling & cyan focus */}
            <div className="min-w-0 lg:col-span-6">
              <div className="relative flex items-center">
                <Search className="pointer-events-none absolute left-3.5 size-4 text-primary sm:left-4 sm:size-4.5" aria-hidden="true" />
                <input type="text" value={searchQuery} onChange={e => onSearchChange?.(e.target.value)} placeholder="Search theories, researchers, papers, or cosmic phenomena..." className="ql-input h-11 w-full rounded-full pl-10 pr-10 text-base text-foreground placeholder:text-muted-foreground focus:outline-none sm:h-12 sm:pl-11 sm:pr-11 sm:text-sm" aria-label="Search dispatches by theory, author, or keyword" />
                {searchQuery.length > 0 && <button type="button" onClick={handleClear} className="absolute right-1 flex size-11 items-center justify-center rounded-full text-muted-foreground transition-colors hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary sm:right-2 sm:size-7" aria-label="Clear search input">
                    <X className="size-4" />
                  </button>}
              </div>
            </div>

            {/* Columns 7–12: Category filter list tags using ql-chip */}
            <div className="min-w-0 w-full max-w-full lg:col-span-6">
              <div role="toolbar" aria-label="Filter research papers by topic" className="flex flex-wrap items-center gap-1.5 sm:gap-2 lg:justify-end">
                {CATEGORIES.map(cat => {
                const isActive = activeCategory === cat.id;
                return <button key={cat.id} type="button" data-active={isActive ? "true" : "false"} onClick={() => onCategoryChange?.(cat.id)} className="ql-chip min-h-[44px] max-w-full text-xs sm:min-h-[36px]">
                      {isActive && <Sparkles className="size-3 shrink-0 text-primary-foreground" />}
                      <span className="truncate">{cat.label}</span>
                    </button>;
              })}
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}